import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { DestroyInWall } from "./DestroyInWall";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";

export class Firecracker extends GameObject {
	spine: SpineGameObject;
	activeSpine: SpineGameObject;
	spineContainer: SpineContainer;
	groundAnimation = "powerup-firecracker-ground";
	skyAnimation = "powerup-firecracker-sky";
	grounded: boolean;
	constructor(scene: GameScene, x: number, y: number, speed: number, grounded: boolean) {
		super(scene);
		this.grounded = grounded;
		let animationName =  grounded ? this.groundAnimation : this.skyAnimation;

		const spine = this.spine = scene.add.spine(0, 0,animationName);
		spine.scale = 0.5;
		spine.y += spine.displayHeight / 2;
		spine.play("idle", true);
		if (!this.grounded) spine.y -= 125;

		const hitboxWidth = spine.displayWidth * 0.8;
		const hitboxHeight = spine.displayHeight * 0.8;
		this.setSize(hitboxWidth, hitboxHeight);

		this.activeSpine = scene.add.spine(0, 0, "powerup-firecracker-active");
		this.activeSpine.visible = false;
		const spineContainer = this.spineContainer = scene.add.spineContainer(0, 0);
		spineContainer.add([spine, this.activeSpine]);
		this.add(spineContainer);
		this.x = x;
		this.y = y + 80;

		// const img = this.addImage("whiteSquare");
		// img.setDisplaySize(hitboxWidth, hitboxHeight);
		// img.alpha = 0.25;

		const planckBody = this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, 
			y: this.y,
			width: hitboxWidth, height: hitboxHeight,
			worldScale: GameScene.worldScale,
			isKinematic: grounded,
			isSensor: false,
		}));
		//planckBody.velocity.x = speed;
		if (grounded) planckBody.velocity.x = speed;

		this.addComponent(new DestroyOffscreen(this, true, false));
		this.addComponent(new DestroyInWall(this));
	}

	playHitAnimation(): void{
		this.spine.play("hit", false);
		this.spine.once("complete", () => {
			this.destroy();
		});
	}
}